import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { MenuTree } from "@/ui/menu-tree";

import InterventionMenuTreeItemDescription from "./intervention-menu-tree-item-description";
import InterventionMenuTreeItemExtra from "./intervention-menu-tree-item-extra";

import "./intervention-menu-tree.style.less";

const InterventionMenuTree = () => {
  const { menuItems, menuSelectedKey, onSectionItemChange } =
    useInterventionSectionContext();

  if (!menuItems.length) return null;

  return (
    <MenuTree
      items={menuItems}
      selectedKey={menuSelectedKey}
      onSelectedItemChange={(menuItem) => onSectionItemChange(menuItem?.data)}
      className="intervention-menu-tree"
      renderDescription={(menuItem) => (
        <InterventionMenuTreeItemDescription menuItem={menuItem} />
      )}
      renderExtra={(menuItem) => (
        <InterventionMenuTreeItemExtra menuItem={menuItem} />
      )}
    />
  );
};

export default InterventionMenuTree;
